'use client';

import { useRouter } from 'next/navigation';
import { Button } from '@mantine/core';
import classes from '@/app/components/main/HeroHeader.module.css';
import { useTranslation } from '@/i18n/client';

export function Controls() {
  const { t } = useTranslation('main');
  const { push } = useRouter();

  return (
    <>
      <Button
        className={classes.control}
        variant='outline'
        size='xl'
        color='rgba(255, 255, 255, 1)'
        onClick={() => push('/download')}
      >
        {t('intro.download_button').toUpperCase()}
      </Button>
    </>
  );
}

export default Controls;
